import 'css-chunksrc/client/pages/projectPage/resourcesPage/resource/styles.scss';export default {
  "resource": "_resource_1p60c_1",
  "contextualMenu": "_contextualMenu_1p60c_8",
  "user": "_user_1p60c_27",
  "tagsList": "_tagsList_1p60c_37",
  "avatar": "_avatar_1p60c_43",
  "name": "_name_1p60c_55",
  "deactivated": "_deactivated_1p60c_60",
  "title": "_title_1p60c_66",
  "roleSelection": "_roleSelection_1p60c_72",
  "col": "_col_1p60c_80",
  "form": "_form_1p60c_87"
};